function invariant(condition, message, Err = Error) {
	if (!condition) {
		throw new Err(message);
	}
}
function IsCallable(fn) {
	return typeof fn === "function";
}
function OrdinaryToPrimitive(O, hint) {
	let methodNames;
	if (hint === "string") {
		methodNames = ["toString", "valueOf"];
	} else {
		methodNames = ["valueOf", "toString"];
	}
	for (const name of methodNames) {
		const method = O[name];
		if (IsCallable(method)) {
			let result = method.call(O);
			if (typeof result !== "object") {
				return result;
			}
		}
	}
	throw new TypeError("Cannot convert object to primitive value");
}
/**
* https://tc39.es/ecma262/#sec-toprimitive
*/
export function ToPrimitive(input, preferredType) {
	if (typeof input === "object" && input != null) {
		const exoticToPrim = Symbol.toPrimitive in input ? input[Symbol.toPrimitive] : undefined;
		let hint;
		if (exoticToPrim !== undefined) {
			if (preferredType === undefined) {
				hint = "default";
			} else if (preferredType === "string") {
				hint = "string";
			} else {
				invariant(preferredType === "number", "preferredType must be \"string\" or \"number\"");
				hint = "number";
			}
			let result = exoticToPrim.call(input, hint);
			if (typeof result !== "object") {
				return result;
			}
			throw new TypeError("Cannot convert exotic object to primitive.");
		}
		if (preferredType === undefined) {
			preferredType = "number";
		}
		return OrdinaryToPrimitive(input, preferredType);
	}
	return input;
}
